import { render } from "./MyProjectList.vue?vue&type=template&id=1f0db2bf"
import script from "./MyProjectList.vue?vue&type=script&lang=js"
export * from "./MyProjectList.vue?vue&type=script&lang=js"

import "./MyProjectList.vue?vue&type=style&index=0&id=1f0db2bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__